/* Local dependencies */
import { GetUserActionTypes, GetUserActions } from '../get-user/redux/action';
import { UpdateUserActionTypes, UpdateUserActions } from '../update-user/redux/actions';
import { User } from '../types';
import defaultAvatar from '../../../assets/images/icons/avatar.svg';

export interface UserState {
  loading: boolean;
  error: null | Error;
  user: User;
}

export const initialUserState: UserState = {
  user: {
    avatar: defaultAvatar,
    email: '',
    id: '',
    points: 0,
    name: '',
  },
  loading: false,
  error: null,
};

export function userReducer(state = initialUserState, action: GetUserActions | UpdateUserActions) {
  switch (action.type) {
    case GetUserActionTypes.GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GetUserActionTypes.GET_USER_SUCCESS: {
      const updatedUser = {
        ...action.payload,
        name: action.payload.name || action.session.tokens.idToken.payload['cognito:username'] || 'Пользователь',
        avatar: action.payload.avatar || defaultAvatar,
        points: action.payload.points || 0,
      };
      
      return {
        ...state,
        loading: false,
        user: updatedUser,
        error: null,
      };
    }
    case GetUserActionTypes.GET_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UpdateUserActionTypes.UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UpdateUserActionTypes.UPDATE_USER_SUCCESS: {
      const updatedUser = {
        ...action.payload,
        avatar: action.payload.avatar || defaultAvatar,
        points: action.payload.points || 0
      };
      return {
        ...state,
        loading: false,
        user: updatedUser,
        error: null,
      };
    }
    case UpdateUserActionTypes.UPDATE_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
